module.exports = __webpack_public_path__ + "img/auth_circle_filled_white.86ec61cf.svg";